import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Icon } from '../icon';
import rem from '../../utils/rem';
import { Box, BoxProps, Flex } from '../primitives';

type Props = Omit<BoxProps, 'color'> & {
  label?: string;
  value?: number;
  values: {
    id: number;
    label: string;
    disabledOption?: boolean;
  }[];
  disabled?: boolean;
  onChange: (id: number) => void;
};

export const Select = ({
  label,
  value,
  values,
  disabled,
  onChange,
  ...rest
}: Props) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      onChange(Number(event.target.value));
    },
    [onChange]
  );

  const color = disabled ? 'secondary' : 'accent';

  return (
    <Flex alignItems="center" flexGrow={0} {...rest}>
      <SSelect
        as="select"
        name={label}
        value={value}
        onChange={handleChange}
        color={color}
        borderColor={color}
      >
        {values.map(({ id, label, disabledOption }) => (
          <SOption
            value={id}
            key={id}
            {...(disabledOption ? { disabled: true } : '')}
          >
            {label}
          </SOption>
        ))}
      </SSelect>
      <Icon
        name="arrow-double"
        color={color}
        size={rem(16)}
        position="absolute"
        right={rem(16)}
        pointerEvents="none"
      />
    </Flex>
  );
};

const SSelect = styled(Box)`
  appearance: none;
  outline: none;
  display: block;
  width: 100%;
  height: ${rem(34)};
  padding: ${`0 ${rem(32)} 0 ${rem(16)}`};
  font-size: ${rem(16)};
  font-weight: 600;
  background-color: #ffffff00;
  border: ${rem(2)} solid;
  border-radius: ${rem(16)};
`;

const SOption = styled.option`
  font-weight: 600;
`;
